import { render, staticRenderFns } from "./Edit3.vue?vue&type=template&id=64908be8&scoped=true&"
import script from "./Edit3.vue?vue&type=script&lang=js&"
export * from "./Edit3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64908be8",
  null
  
)

export default component.exports